<template>
  <div>
    <!-- onSubmit måste vara false för att inte ladda om sidan vid submit-->
    <form
      class="content pure-form pure-form-stacked"
      onSubmit="return false;"
    >
      <fieldset>
        <div class="pure-g slide-mar">
          <div class="pure-u-1">
            <input
              v-model="name"
              class="pure-input-rounded pure-input-1"
              type="text"
              placeholder="Namn på dryck(er)..."
              @keyup.enter="scrollToProductTable"
            >
          </div>
        </div>
        <div class="pure-g slide-mar">
          <div class="pure-u-1 bott-mar">
            <h3 class="content-subhead">
              APK (ml)
            </h3>
            <vue-slider
              v-model="apkInterval"
              :min="0"
              :max="10"
              :marks="apk_marks"
              :contained="true"
              :drag-on-click="true"
              :interval="0.1"
              :enable-cross="false"
            />
          </div>
          <div class="pure-u-1 bott-mar">
            <h3 class="content-subhead">
              Pris (SEK)
            </h3>
            <vue-slider
              v-model="priceInterval"
              :min="0"
              :max="1000"
              :marks="price_marks"
              :contained="true"
              :drag-on-click="true"
              :enable-cross="false"
            />
          </div>
          <div class="pure-u-11-24 bott-mar">
            <h3
              class="content-subhead"
              style="font-size:146%;padding-top:5px;"
            >
              Volym (cl)
            </h3>
            <vue-slider
              v-model="volumeInterval"
              :min="0"
              :max="600"
              :marks="volume_marks"
              :contained="true"
              :drag-on-click="true"
              :enable-cross="false"
            />
          </div>
          <div class="pure-u-2-24 bott-mar" />
          <div class="pure-u-11-24 bott-mar">
            <h3
              class="content-subhead"
              style="font-size:146%;padding-top:5px;white-space: nowrap; overflow: visible"
            >
              Alkoholhalt (%)
            </h3>
            <vue-slider
              v-model="alcvolInterval"
              :min="0"
              :max="100"
              :marks="alcvol_marks"
              :contained="true"
              :drag-on-click="true"
              :enable-cross="false"
            />
          </div>
        </div>
        <div class="pure-g">
          <div class="pure-u-1">
            <h3 class="content-subhead">
              Kategori
            </h3>
          </div>
        </div>
        <div class="pure-g">
          <div class="pure-u-1-4">
            <label
              class="pure-checkbox"
              for="ol-cider"
            > <input
              id="ol-cider"
              v-model="categories"
              type="checkbox"
              value="Öl &amp; cider"
            > Öl & Cider</label>
          </div>
          <div class="pure-u-1-4">
            <label
              class="pure-checkbox"
              for="vin"
            ><input
              id="vin"
              v-model="categories"
              type="checkbox"
              value="vin"
            > Vin</label>
          </div>
          <div class="pure-u-1-4">
            <label
              class="pure-checkbox"
              for="sprit"
            ><input
              id="sprit"
              v-model="categories"
              type="checkbox"
              value="sprit"
            > Sprit</label>
          </div>
          <div class="pure-u-1-4">
            <label
              class="pure-checkbox"
              for="likor"
            ><input
              id="likor"
              v-model="categories"
              type="checkbox"
              value="likör"
            > Likör</label>
          </div>
        </div>
        <div class="pure-g" />
        <v-collapse-wrapper>
          <div
            v-collapse-toggle
            class="pure-u-1"
          >
            <h3 class="content-subhead hoverable">
              <a
                href="jacascript:void(0);"
                class="clickable-text"
              >
                Underkategori <span style="position: relative; top: .1em;">▼</span>
              </a>
            </h3>
          </div>
          <div
            v-collapse-content
            class="pure-g content"
            style="background-color: #F6F6F6; border-radius: 15px"
          >
            <span
              v-if="categories.length == 0"
              class="pure-u-1"
            >Välj minst en kategori för att se underkategorier!</span>
            <!-- För att välja alla -->
            <div class="pure-u-2-5" />
            <div class="pure-u-1-5">
              <label
                class="pure-checkbox"
                style="font-weight: bold"
              ><input
                id="checkAll"
                v-model="checkAll"
                type="checkbox"
                checked="checked"
              > Alla</label>
            </div>
            <div class="pure-u-2-5" />
            <!-- Var och en -->
            <div
              v-for="subcategory in availableSubcategories"
              :key="subcategory"
              class="pure-u-4-24"
            >
              <label
                class="pure-checkbox"
                :for="subcategory"
              ><input
                :id="subcategory"
                v-model="subcategories"
                type="checkbox"
                :value="subcategory"
                checked="checked"
              > {{ subcategory }}</label>
            </div>
          </div>
        </v-collapse-wrapper>
      </fieldset>
    </form>
    <div
      id="productTable"
      class="subcontent container-fluid product-table"
      style="margin-top: -70px;"
    >
      <!-- table-responsive makes the damn thing scrollable on mobile -->
      <div
        class="table-responsive"
      >
        <vuetable
          ref="vuetable"
          class="table table-striped product-table"
          :css="{loadingClass: 'Vänligen vänta...'}"
          no-data-template="<i>Inga produkter hittades :/</i>"
          :api-mode="false"
          :data-manager="dataManager"
          :fields="fields"
        >
          <!-- To give names links to the product-->
          <div
            slot="name"
            slot-scope="props"
          >
            <a
              :href="props.rowData.url"
              target="_blank"
              style="color:darkorange"
            >{{ props.rowData.name }}</a>
          </div>
          <!-- Price per shot -->
          <div
            slot="pps"
            slot-scope="props"
          >
            <!-- Yeah it's crap but Vuetable-2 debands it -->
            <!-- PPS == 40 ml * 0,4 / (mlAPK) == 16 / mlAPK-->
            <!-- ALSO: If APK == 0 the thing will explode -->
            <div v-if="props.rowData.apk == 0">
              <span>N/A</span>
            </div>
            <div v-else>
              <span>{{ ((16 / props.rowData.apk)).toFixed(2).toString().replace(".", ",") }}&nbsp;SEK</span>
            </div>
          </div>
          <!-- For small icons for categories -->
          <div
            slot="category"
            slot-scope="props"
          >
            <div v-if="props.rowData.category === 'Öl & Cider'">
              <span>🍻 Öl & Cider</span>
            </div>
            <div v-else-if="props.rowData.category === 'Vin'">
              <span>🍷 Vin</span>
            </div>
            <div v-else-if="props.rowData.category === 'Sprit'">
              <span>🍸 Sprit</span>
            </div>
            <div v-else-if="props.rowData.category === 'Likör'">
              <span>🥃 Likör</span>
            </div>
            <div v-else>
              <span> {{ props.rowData.category }}</span>
            </div>
          </div>
        </vuetable>
        <div style="padding-top:10px" />
      </div>
    </div>
  </div>
</template>

<script>
// Local include of the slider
import VueSlider from 'vue-slider-component'
import '@/styles/custom-slider.css'
import Vuetable from 'vuetable-2'
import fieldsDef from '@/scripts/fieldsDef.js'
import orderBy from 'lodash.orderby'
import debounce from 'lodash.debounce'

const defaultMaxItems = 20;
const API_BASE_URL = "https://api.apkollen.se";

export default {
    name: "ApkApp",
    metaInfo: {
      title: "Topplistan | APKollen.se",
      meta: [
        { description: "Vi listar dryckessortimentet hos BorderShop efter APK (Alkohol Per Krona), PPS (Pris Per Shot) etc. Se vilken öl, sprit, och vilket vin som ger mest per krona!" },
      ]
    },
    components: {
        VueSlider,
        Vuetable,
    },
    data: function () {
        return {
            name: "", // To be converted to list
            categories: ["Öl & cider", "vin", "sprit", "likör"], // To be checked at the beginning
            subcategories: [],
            apkInterval: [0, 10],
            priceInterval: [0, 1000],
            alcvolInterval: [0, 100],
            volumeInterval: [0, 600],
            sortOrder: ["rank", "asc"],
            maxItems: defaultMaxItems,
            data: [],
            // Following are for handling subcats
            availableSubcategories: [],
            checkAll: true, // For check all bos
            // Following are for sliders
            // As dict to make + possible
            apk_marks: {0: "0", 2.5: "2,5", 5: "5", 7.5: "7,5", 10: "10+"}, // Marks for sliders
            price_marks: {0: "0", 10: "10", 100: "100", 250: "250", 500: "500", 750: "750", 1000: "1000+"},
            volume_marks: {0: "0", 33: "33", 100: "100", 200: "200", 400: "400", 600: "600+"},
            alcvol_marks: [0, 4.5, 12, 20, 40, 60, 80, 100],
            // We leave out article_nbr, IDGAF
            // Following are for VueTable-2
            // Defining our fields
            fields: fieldsDef,
            // Change in dev
        }
    },

    // Checks for changes to variables,
    // calls function after input is complete
    // debouncedGetResults waits a bit before sending
    // API request
    watch: {
        categories: function() {
            this.debouncedGetAvailableSubcategories(); // No need to get results, subcats will get them
        },
        name: function() {
            this.maxItems = defaultMaxItems; // The user is at the top of the screen, no need to reload all in infinityscroll
            this.debouncedGetResults();
        },
        // Memoization to prevent calling product API twice on startup
        subcategories: (function () {
            let firstChange = true;

            return function () {
              if (!firstChange) {
                this.maxItems = defaultMaxItems;
                this.debouncedGetResults();
              } else {
                firstChange = false;
              }
            }
        })(),
        apkInterval: function() {
            this.maxItems = defaultMaxItems;
            this.debouncedGetResults();
        },
        priceInterval: function() {
            this.maxItems = defaultMaxItems;
            this.debouncedGetResults();
        },
        alcvolInterval: function() {
            this.maxItems = defaultMaxItems;
            this.debouncedGetResults();
        },
        volumeInterval: function() {
            this.maxItems = defaultMaxItems;
            this.debouncedGetResults();
        },
        // So that vuetable updates
        data: function() {
            this.$refs.vuetable.refresh();
        },
        // So that subcat updates, also 
        // force empty subcat in request
        checkAll: function() {
            if (this.checkAll === true) {
                this.subcategories = this.availableSubcategories;
            } else if (this.checkAll === false) {
                this.subcategories = [];
            }
        },
    },

    // Create debounced functions at startup
    created: function() {
        this.debouncedGetResults = debounce(this.getResults, 500);
        this.debouncedGetAvailableSubcategories = debounce(this.getAvailableSubcategories, 500);
        this.getAvailableSubcategories();
        this.getResults(); // First time should be FAST
    },

    // For infinate scroll
    mounted() {
        // We need to wait just a bit, since it will run immediatly otherwise
        setTimeout(this.reloadIfAtBottom, 500)
    },

    methods: {
        reloadIfAtBottom: function() {
            // Check scrolling; If at bottom, increase maxitems and get new results!
            window.onscroll = () => {
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                    this.maxItems = this.maxItems * 2; // If scroll many fast
                    this.getResults(); // No need to debounce
                }
            };
        },
        // For scrolling when hitting enter
        scrollToProductTable: function () {
            // Some delay to look smoother for long searches
            setTimeout(() => {
                const productTable = document.getElementById("productTable");
                productTable.scrollIntoView({
                    behavior: "smooth"
                });
            }, 250);
        },
        getAvailableSubcategories: function () {
            if (this.categories.length === 0) {
              this.subcategories = [];
              this.availableSubcategories = [];
              return this.availableSubcategories;
            } else {
              let url = API_BASE_URL + "/subcategory";
              let query = JSON.stringify(this.categories);

              fetch(url, { method: "POST", body: query })
                  .then(res => {
                      return res.json();
                  })
                  .then(res => {
                      // Now we want all incoming subcats to be selected
                      this.checkAll = true;
                      this.subcategories = res;
                      this.availableSubcategories = res;
                      return this.availableSubcategories;
                  })
                  .catch(err => {
                      console.error(err)
                  });
            }
        },
        getResults: function () {
            let url = API_BASE_URL;

            // We don't want to request an empty name
            let nameList = [];
            if (this.name !== "") {
              nameList = this.name.split(",");  // We want a list, handle commas as separators
            }

            let query = JSON.stringify({
                name: nameList,
                category: this.categories,
                subcategory: this.subcategories,
                // If maxed out, only send lower bound
                volume: (this.volumeInterval[1] == 600 ? [this.volumeInterval[0]] : this.volumeInterval),
                alcvol: this.alcvolInterval, // Nothing over 100%, skip this
                price: (this.priceInterval[1] == 1000 ? [this.priceInterval[0]] : this.priceInterval),
                apk: (this.apkInterval[1] == 10 ? [this.apkInterval[0]] : this.apkInterval),
                // Cannot sort on rank for now (or ever? API allows it anyway)
                sortOrder: this.sortOrder,
                maxItems: this.maxItems,
            });

            fetch(url, { method: "POST", body: query })
                .then(res => {
                    return res.json();
                })
                .then(res => {
                    if (res.length > 0) {
                        this.data = res;
                    } else {
                        this.data = [];
                        // En fullösning. Om vuetable har haft ett värde,
                        // men får ett tomt uppdateras det ej. Man måste
                        // fibbla fram det själv.
                        this.$refs.vuetable.tableData = [];
                    }
                    return this.data;
                })
                .catch(err => {
                    console.error(err)
                });
        },
        // Tells VueTable-2 how to sort the data
        // Memoize if this was the last func to
        // fetch new data to prevent loop
        dataManager: (function () {
            let lastUpdateByThisFunc = false;

            return (function (newSortOrder) {
                // If no sort order, we just use available data
                if (!newSortOrder[0]) {
                    let data = this.data;
                    return data;
                }

                // No need to sort nothing
                if (this.data.length < 1) return;

                let sortedData;

                if (newSortOrder.length > 0) {

                    // Must check if data was last updated by this very function
                    // to prevent loops
                    if (!lastUpdateByThisFunc) {
                        lastUpdateByThisFunc = true;
                        this.sortOrder[0] = newSortOrder[0].sortField;
                        this.sortOrder[1] = newSortOrder[0].direction;
                        this.getResults();
                    } else if (lastUpdateByThisFunc) {
                        lastUpdateByThisFunc = false;
                    }
                    sortedData = orderBy(
                        this.data,
                        newSortOrder[0].sortField,
                        newSortOrder[0].direction
                    );
                }
                return sortedData;
            });
        })(),
    },
}

</script>

<style>
/* Styling/Defining classes, mostly used to get margins */
.bott-mar {
    margin-bottom: 20px;
}
.slide-mar {
    margin-left: 0px;
    margin-right: 0px;
}
.v-collapse-content{
    max-height: 0;
    transition: max-height 0.3s ease-out;
    overflow: hidden;
    padding: 0;
}
   
.v-collapse-content-end{
    transition: max-height 0.3s ease-in;
    max-height: 69420px;
}
/* For our nice dropdown menu */
.hoverable:hover {
    color: rgb(83, 83, 83);
}
.product-table {
    table-layout: fixed;
    display: -webkit-box; 
    width: 100%;
    word-wrap: break-word;
    border-radius: 15px;
    font-size: .9em;
}
</style>
